import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class Inject extends Component {

  constructor(props, context) {
    super(props, context);
  }

  getChildContext() {
    return { providers: this.props.providers };
  }

  render() {
    return (<div>{this.props.children}</div>);
  }
}

Inject.propTypes = {
  providers: PropTypes.object,
  children: PropTypes.object
};

Inject.childContextTypes = {
  providers: PropTypes.object
};



// WEBPACK FOOTER //
// ./providers/inject.js